var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"login"},[_c('main',{staticClass:"main"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.localError)?_c('div',{staticClass:"alert alert-danger col",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.localError))]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('Loader'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb8a498","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/VerifyEmail.vue
// module id = OUZv
// module chunks = 1